// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__3IfbF","rootCenter":"LoadMoreObserver_rootCenter__2X_eW","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__uQxEK"};